module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1049.5f847c9f.png";